// extracted by mini-css-extract-plugin
module.exports = {"main-component":"stepBack_main-component__3g8IJ"};